// Packages
import { Component } from "react";
import { Link, Redirect } from "react-router-dom";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
import { getFromLocalStorage } from "../../utils/webStorage";
import ReactPaginate from "react-paginate";

// Assets
import playbtn from "../../assets/images/playbtn.svg";
import bluePlayStream from "../../assets/images/bluePlayStream.png";
import recentMatches from "../../assets/images/recentMatches.png";
import getbackarrow from "../../assets/images/getbackarrow.svg";
import upcomingIcon from "../../assets/images/upcomingIcon.svg";
import blankProfile from "./images/blank-profile.png";
import moment from "moment";

// Services
import userService from "../../services/user.service";

class schoolAdminFeed extends Component {
  state = {
    anchorEl: null,
    schoolId: "",
    liveGameDashboardResponses: [],
    recentGameDashboardResponses: [],
    upcommingGameDashboardResponses: [],
    liveGameDashboardResponsesFlag: false,
    recentGameDashboardResponsesFlag: false,
    upcommingGameDashboardResponsesFlag: false,
    activityResponses: [],
    totalPages: null,
    submitting: false,
    schoolLogo: null,
    schoolName: "",
    activityFlag: true,
    redirect: false,
    eventId: "",
    playlistId: "",
    categoryId: "",
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  componentDidMount() {
    const feed = document.getElementById("Activity History");
    const schoolName = getFromLocalStorage("schoolName");
    var schoolLogo = getFromLocalStorage("schoolLogo");
    if (feed) {
      feed.classList.add("btnActive");
    }
    const schoolId = getFromLocalStorage("schoolId");
    this.setState({ schoolId, schoolName, schoolLogo });
    this.getSchoolFeed(schoolId);
    // this.getActivityToShow()
  }

  getActivityToShow() {
    this.setState({
      submitting: true,
    });
    userService.getSchoolActivity().then((res) => {
      const activityResponses = res.data.data.activityResponses;
      let activityFlag = true;
      if (activityResponses.length !== 0) {
        activityFlag = false;
      }
      const totalPages = res.data.data.totalPages;
      this.setState({ activityResponses, activityFlag, totalPages }, () =>
        this.setState({ submitting: false })
      );
    });
  }

  handlePageClick(e) {
    const page = e.selected;
    const pageSend = page;
    const size = 10;
    userService.getAllActivityByPage(pageSend, size).then((res) => {
      const activityResponses = res.data.data.activityResponses;
      this.setState({ activityResponses });
    });
  }

  storagePlaylist(data, eventId, playlistId, categoryId) {
    this.setState({ eventId, playlistId, categoryId, redirect: true });
  }

  getSchoolFeed(schoolId) {
    userService
      .getSchoolAdminDashboardData(schoolId)
      .then((response) => {
        var liveGameDashboardResponses =
          response.data.data.liveGameDashboardResponses;
        var recentGameDashboardResponses =
          response.data.data.recentGameDashboardResponses;
        var upcommingGameDashboardResponses =
          response.data.data.upcommingGameDashboardResponses;
        if (liveGameDashboardResponses.length !== 0) {
          var liveGameDashboardResponsesFlag = true;
          this.setState({ liveGameDashboardResponsesFlag });
        }
        if (recentGameDashboardResponses.length !== 0) {
          var recentGameDashboardResponsesFlag = true;
          this.setState({ recentGameDashboardResponsesFlag });
        }
        if (upcommingGameDashboardResponses.length !== 0) {
          var upcommingGameDashboardResponsesFlag = true;
          this.setState({ upcommingGameDashboardResponsesFlag });
        }
        this.setState({
          recentGameDashboardResponses,
          upcommingGameDashboardResponses,
          liveGameDashboardResponses,
        });
        this.setState({
          submitting: false,
        });
      })

      .catch((error) => {
        console.error("There was an error!", error);
        this.setState({
          submitting: false,
        });
      });
  }

  tConvert = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? "AM" : "PM";
      time[0] = +time[0] % 12 || 12;
    }
    let timeformat = time.join("");
    if (timeformat.length === 10) {
      timeformat = timeformat.slice(0, 5) + " " + timeformat.slice(8, 10);
    } else {
      timeformat = timeformat.slice(0, 4) + " " + timeformat.slice(7, 9);
    }
    return timeformat;
  };

  dConvert = (d) => {
    var date = new Date(moment(d).format());
    date =
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear();
    return date;
  };

  render() {
    const {
      activityFlag,
      recentGameDashboardResponses,
      upcommingGameDashboardResponses,
      redirect,
      liveGameDashboardResponses,
      liveGameDashboardResponsesFlag,
      recentGameDashboardResponsesFlag,
      upcommingGameDashboardResponsesFlag,
      activityResponses,
      totalPages,
      schoolLogo,
      schoolName,
      submitting,
      eventId,
      playlistId,
      categoryId,
    } = this.state;

    if (redirect) {
      return (
        <Redirect
          to={`/videoplayer/${eventId}/${playlistId}/${categoryId}/null`}
        />
      );
    }
    return (
      <div className={submitting ? "gray-out" : " "}>
        <SchoolAdminDashboard />
        <div className="content-layout">
          <div className="row mt-0">
            <div className="col-12 col-sm-12 col-md-8 col-lg-8  ">
              <div className="moboplpr-0">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="col-md-12 col-lg-12">
                    <h2 className="fs-28 bold black mobofs36 pb-2">
                      Activity History
                    </h2>
                    <div className="clear10"></div>
                  </div>
                </div>

                {activityResponses &&
                  activityResponses.map((item, index) => (
                    <div className="main-card-box pd-10" key={index}>
                      <div className="d-flex-space-between brderbtm custom-column-for-mobile">
                        <div>
                          <span className="fs-16 regular">
                            You were working on this playlist in the library.
                          </span>
                        </div>
                        <div>
                          <label className="time-label-for-activity-history">
                            {item.lastSeen}
                          </label>
                        </div>
                      </div>
                      <div className="d-flex-space-between mg-top-10">
                        <div>
                          <div className="d-flex-space-between mg-top-10">
                            <div className="d-flex-space-between mg-top-10">
                              <div className="d-flex-space-between width-100">
                                <div
                                  className="width-70 text-column d-flex-align-cent"
                                  style={{ width: "70% !important" }}
                                >
                                  <div>
                                    <img
                                      src={playbtn}
                                      alt="Coaches"
                                      className="mg-right-15"
                                    />
                                  </div>
                                  <div
                                    className="d-flex-space-between width-100"
                                    style={{ width: "100%" }}
                                  >
                                    <p className="bold fs-18">
                                      {schoolName}
                                      <span className="vs-label-small">vs</span>
                                      {item.school2Name}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mg-left-30">
                            <p className="mg-bottom-15 mg-top-20">
                              {item.playlistName}
                            </p>
                            <button
                              type="button"
                              className="btn-back"
                              onClick={() =>
                                this.storagePlaylist(
                                  item.playlistName,
                                  item.eventId,
                                  item.playlistId,
                                  item.categoryId
                                )
                              }
                            >
                              <img
                                src={getbackarrow}
                                alt="back"
                                className="getback"
                                onClick={() =>
                                  this.storagePlaylist(
                                    item.playlistName,
                                    item.eventId,
                                    item.playlistId,
                                    item.categoryId
                                  )
                                }
                              />
                              Get Back Here
                            </button>
                          </div>
                        </div>
                        <div
                          className="d-flex-align-right"
                          style={{ width: "30%", height: "100%" }}
                        >
                          <video
                            src={item.thumbnailUrl}
                            alt="coach"
                            className="thumbnail-2"
                          ></video>
                        </div>
                      </div>
                    </div>
                  ))}

                {activityResponses.length > 10 && (
                  <div>
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next >"
                      onPageChange={(e) => this.handlePageClick(e)}
                      pageRangeDisplayed={10}
                      pageCount={totalPages}
                      previousLabel="< Previous"
                      renderOnZeroPageCount={null}
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="activetab"
                    />
                  </div>
                )}
                {activityFlag && submitting === false && (
                  <div className="row">
                    <div className="col-lg-12">
                      <p className="nodatabox">
                        No Activity History available currently.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="clear20"></div>

              <div className="clear20"></div>

              <div className="clear20"></div>

              <div className="clear20"></div>
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-4">
              {liveGameDashboardResponsesFlag && (
                <div className="col-12 col-sm-11 col-md-12 col-lg-12 pl-0">
                  <div className="row">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                      <div className="red-dot disin"></div>{" "}
                      <span className="fs-20 reguar black">Live</span>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 text-right">
                      <img src={bluePlayStream} alt="Play" />
                      <span className="link fs-16 regular txtd">Stream</span>
                    </div>
                  </div>
                  <div className="clear10"></div>
                </div>
              )}
              {liveGameDashboardResponses &&
                liveGameDashboardResponses.map((item, index) => (
                  <div
                    className="col-11 col-sm-11 col-md-12 col-lg-12 pl-0"
                    key={index}
                  >
                    <div className="live-style-card">
                      <div class="col-md-12 col-lg-12 text-center pt-3">
                        <div class="clear10"></div>
                        <span className="fs-16 black regular">
                          {item.eventDate}
                          {",  "}
                          {this.tConvert(item.eventTime)}
                        </span>
                        <div>
                          <span className="fs-16 black regular">
                            {item.location}
                          </span>
                        </div>
                      </div>
                      <div className="row m-0">
                        <div className="col-4 col-sm-5 col-md-5 text-center plr">
                          <div className="clear30"></div>
                          <div className="grey-box mx-auto">
                            <img
                              className="teamImg"
                              src={schoolLogo}
                              alt=""
                            ></img>
                          </div>
                          <div className="clear10"></div>
                          <label className="fs-14 regular black bold">
                            {schoolName}
                          </label>
                        </div>
                        <div className="col-4 col-sm-2 col-md-2 p-0 text-center">
                          <div className="clear10"></div>

                          <label className="fs-28 bold">
                            {item.team1Score} : {item.team2Score}
                          </label>
                          <div className="clear10"></div>
                          <label className="fs-18 regular pt-3 vs-label">
                            VS
                          </label>
                        </div>
                        <div className="col-4 col-sm-5 col-md-5 text-center plr">
                          <div className="clear30"></div>
                          <div className="grey-box mx-auto">
                            <img
                              className="teamImg"
                              src={
                                item.school2ProfilePhoto
                                  ? item.school2ProfilePhoto
                                  : blankProfile
                              }
                              alt=""
                            ></img>
                          </div>
                          <div className="clear10"></div>
                          <label className="fs-14 regular black">
                            {item.school2Name}
                          </label>
                        </div>
                      </div>
                      <div className="clear20"></div>
                    </div>
                    <div className="clear20"></div>
                  </div>
                ))}
              <div id="hideUpcoming">
                {upcommingGameDashboardResponsesFlag && (
                  <div className="row m-b pb-2">
                    <div className="col-6 col-sm-6 col-md-8 col-lg-8 pl-0 d-flex pt-2">
                      <img
                        src={recentMatches}
                        alt="recentMatches"
                        className="clock"
                      />{" "}
                      <label className="fs-20 semi-bold black disin">
                        Upcoming Games
                      </label>
                    </div>
                    <div className="col-6 col-sm-6 col-md-4 col-lg-4 text-right pt-2">
                      <Link to="/schoolevents">
                        <span className="link txtd fs-16 semi-bold cp pr-2">
                          See All
                        </span>
                      </Link>
                    </div>
                  </div>
                )}
                {upcommingGameDashboardResponses &&
                  upcommingGameDashboardResponses.map((item, index) => (
                    <div
                      className="col-11 col-sm-11 col-md-12 col-lg-12 pl-0"
                      key={index}
                    >
                      <div className="live-style-card mb-4">
                        <div className="row m-0">
                          <div className="col-md-12 col-lg-12 text-center pt-3">
                            <div className="clear10"></div>
                            <span className="fs-16 black regular">
                              {this.dConvert(item.eventDate)}
                              {",  "}
                              {this.tConvert(item.eventTime)}
                            </span>
                            <div>
                              <span className="fs-16 black regular">
                                {item.location}
                              </span>
                            </div>
                          </div>
                          <div className="col-4 col-sm-5 col-md-5 text-center plr">
                            <div className="clear20"></div>
                            <div className="grey-box mx-auto">
                              <img
                                className="teamImg"
                                src={schoolLogo}
                                alt=""
                              ></img>
                            </div>
                            <div className="clear10"></div>
                            <label className="fs-16 medium dblack">
                              {schoolName}
                            </label>
                          </div>
                          <div className="col-4 col-sm-2 col-md-2 p-0 text-center">
                            <div className="clear20"></div>
                            <label className="fs-28 bold"></label>
                            <div className="clear10"></div>
                            <label className="fs-18 regular pt-3 vs-label">
                              VS
                            </label>
                          </div>
                          <div className="col-4 col-sm-5 col-md-5 text-center plr">
                            <div className="clear20"></div>
                            <div className="grey-box mx-auto">
                              <img
                                className="teamImg"
                                src={
                                  item.school2ProfilePhoto
                                    ? item.school2ProfilePhoto
                                    : blankProfile
                                }
                                alt=""
                              ></img>
                            </div>
                            <div className="clear10"></div>
                            <label className="fs-16 medium dblack">
                              {item.school2Name}
                            </label>
                          </div>
                        </div>
                        <div className="clear20"></div>
                      </div>
                    </div>
                  ))}
                {recentGameDashboardResponsesFlag && (
                  <div className="row m-b pb-2">
                    <div className="col-6 col-sm-6 col-md-8 col-lg-8 pl-0 d-flex mt-1">
                      <img
                        src={upcomingIcon}
                        alt="recentMatches"
                        className="upcoming-icon"
                      />{" "}
                      <label className="fs-20 semi-bold black disin">
                        Recent Games
                      </label>
                    </div>
                    <div className="col-6 col-sm-6 col-md-4 col-lg-4 text-right">
                      <Link to={`/schoolevents?pastEvent=${1}`}>
                        <span className="link txtd fs-16 semi-bold cp mr-2">
                          See All
                        </span>
                      </Link>
                    </div>
                  </div>
                )}
                {recentGameDashboardResponses &&
                  recentGameDashboardResponses.map((item, index) => (
                    <div
                      className="col-11 col-sm-11 col-md-12 col-lg-12 pl-0"
                      key={index}
                    >
                      <div className="live-style-card mb-4">
                        <div className="row m-0">
                          <div className="col-md-12 col-lg-12 text-center pt-3">
                            <div className="clear10"></div>
                            <span className="fs-16 black regular ">
                              {item.eventDate}
                              {",  "}
                              {this.tConvert(item.eventTime)}
                            </span>
                            <div>
                              <span className="fs-16 black regular">
                                {item.location}
                              </span>
                            </div>
                          </div>
                          <div className="col-4 col-sm-5 col-md-5 text-center plr">
                            <div className="clear30"></div>
                            <div className="grey-box mx-auto">
                              <img
                                className="teamImg"
                                src={schoolLogo}
                                alt=""
                              ></img>
                            </div>
                            <div className="clear10"></div>
                            <label className="fs-16 medium dblack">
                              {schoolName}
                            </label>
                          </div>
                          <div className="col-4 col-sm-2 col-md-2 p-0 text-center">
                            <div className="clear30"></div>
                            <label className="fs-28 bold">
                              {item.team1Score} : {item.team2Score}
                            </label>
                            <div className="clear10"></div>
                            <label className="fs-18 regular pt-3 vs-label">
                              VS
                            </label>
                          </div>
                          <div className="col-4 col-sm-5 col-md-5 text-center plr">
                            <div className="clear30"></div>
                            <div className="grey-box mx-auto">
                              <img
                                className="teamImg"
                                src={
                                  item.school2ProfilePhoto
                                    ? item.school2ProfilePhoto
                                    : blankProfile
                                }
                                alt=""
                              ></img>
                            </div>
                            <div className="clear10"></div>
                            <label className="fs-16 medium dblack">
                              {item.school2Name}
                            </label>
                          </div>
                        </div>
                        <div className="clear20"></div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default schoolAdminFeed;
